import React from 'react';

export default function EditControls({ 
  isEditing, 
  saving, 
  onEdit, 
  onSave, 
  onCancel 
}) {
  return (
    <div className="mb-3">
      {/* Status alerts */}
      {isEditing && !saving && (
        <div className="alert alert-warning mb-3">
          <i className="bi bi-pencil-square me-2"></i>
          <strong>Edit Mode Active</strong> - Make your changes across all tabs and save when done
        </div>
      )}
      {saving && (
        <div className="alert alert-info mb-3">
          <div className="d-flex align-items-center">
            <div className="spinner-border spinner-border-sm me-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <strong>Saving changes...</strong>
          </div>
        </div>
      )}
      
      {/* Centered edit buttons */}
      <div className="d-flex justify-content-center">
        {!isEditing && !saving ? (
          <button 
            className="btn btn-outline-primary"
            onClick={onEdit}
          >
            <i className="bi bi-pencil me-1"></i>
            Click me to Update Information
          </button>
        ) : isEditing && !saving ? (
          <div className="d-flex gap-2">
            <button 
              className="btn btn-success" 
              onClick={onSave}
              disabled={saving}
            >
              <i className="bi bi-check-lg me-1"></i>
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
            <button 
              className="btn btn-secondary" 
              onClick={onCancel}
              disabled={saving}
            >
              <i className="bi bi-x-lg me-1"></i>
              Cancel
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}